module.exports = __webpack_public_path__ + "img/chat.30b8e1f6.svg";